import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CLOSED_LA_COOKIE } from 'constants/cookies';
import { HYDRA_LASD, HYDRA_PERSONALIZATION_MARKER } from 'constants/hydraTests';

import { inIframe } from 'helpers/CheckoutUtils';
import { getAssignmentGroup, triggerAssignment } from 'actions/ab';
import { redirectToAuthenticationFor } from 'actions/redirect';
import { onCloseLoginAssistantClick, onLoginFromLoginAssistantClick, onShowLoginAssistant } from 'store/ducks/loginAssistant/actions';
import llamaImage from 'images/llama-circle.svg';
import css from 'styles/components/loginAssistant.scss';
import { close as modalClose } from 'styles/components/common/modal.scss';

export class LoginAssistant extends Component {
  state = {
    isShown: true
  };

  componentDidMount() {
    const { marketplace: { showLoginAssistant } } = this.context;
    const { hideLADueToCustomerClosedIt, isRecognizedCustomer, triggerAssignment } = this.props;
    if (showLoginAssistant && !hideLADueToCustomerClosedIt && !isRecognizedCustomer) {
      triggerAssignment(HYDRA_PERSONALIZATION_MARKER);
      triggerAssignment(HYDRA_LASD);
    }
  }

  componentDidUpdate() {
    const { hideLADueToCustomerClosedIt, isRecognizedCustomer } = this.props;
    const { isShown } = this.state;
    const isHidden = hideLADueToCustomerClosedIt || isRecognizedCustomer || !isShown;

    if (!isHidden) {
      this.props.onShowLoginAssistant();
    }
  }

  onHideLoginAssistantFromLinkClick = e => {
    e.preventDefault();
    this.setState({ isShown: false });
    this.props.onCloseLoginAssistantClick();
  }

  onGoToLoginClick = e => {
    const { isInDealsTest, redirectToAuthenticationFor } = this.props;
    e.preventDefault();

    if (isInDealsTest) {
      redirectToAuthenticationFor({ pathname: '/deals-for-you', search: '' });
    } else {
      const { locationBeforeTransitions: { pathname }, onLoginFromLoginAssistantClick } = this.props;
      onLoginFromLoginAssistantClick(pathname);
    }
  }

  makeDefaultBubbleContent() {
    return (
      <>
        Returning customers enjoy a tailored shopping experience:
        <ul>
          <li>Size recommendations on product pages</li>
          <li>"Best for You" search results</li>
          <li>Zappos Rewards members get points for purchases and logging in</li>
        </ul>
      </>
    );
  }

  makeDealsBubbleContent() {
    return (
      <span style={{ fontSize: 16 }}>
        <span role="img" aria-label="eyes emoji">👀</span> Get your personalized deals…just sign in to see them! <span role="img" aria-label="tada emoji">🎉</span>
      </span>
    );
  }

  makeBubbleContent() {
    const { isInDealsTest } = this.props;
    return isInDealsTest ? this.makeDealsBubbleContent() : this.makeDefaultBubbleContent();
  }

  makeDefaultHeader() {
    return 'Sign in for personalized recommendations!';
  }

  makeDealsHeader() {
    return 'Deals for you!';
  }

  makeHeader() {
    const { isInDealsTest } = this.props;
    return isInDealsTest ? this.makeDealsHeader() : this.makeDefaultHeader();
  }

  render() {
    const { marketplace: { showLoginAssistant }, testId } = this.context;

    if (!showLoginAssistant || inIframe()) {
      return null;
    }

    const { dealsGroup, hideLADueToCustomerClosedIt, isRecognizedCustomer, hydraPersonalizationMarker } = this.props;
    const { isShown } = this.state;

    if (hideLADueToCustomerClosedIt || isRecognizedCustomer) {
      return null;
    }

    const personalizedImage = !!hydraPersonalizationMarker && <span className={css.pRecMrkSmall} aria-label="Personalization icon" />;

    return (
      <aside
        data-test-id={testId('loginAssistant')}
        className={cn(css.wrapper, { [css.fadeOut]: !isShown })}
        role="dialog">
        <div className={css.modalHeader}>
          <p className={css.header}>
            {personalizedImage}
            {this.makeHeader()}
          </p>
          <button
            type="button"
            onClick={this.onHideLoginAssistantFromLinkClick}
            className={modalClose}
            data-test-id={testId('closeModal')}
            aria-label="Close" />
        </div>

        <div className={css.lasBody}>
          <div className={css.speechBubble}>
            {this.makeBubbleContent()}
          </div>
          <img src={llamaImage} alt="" />
        </div>

        <div className={css.footer}>
          <form action={'tbd'} method="post">
            <button
              type="button"
              disabled={false}
              onClick={this.onHideLoginAssistantFromLinkClick}
              className={css.cancelBtn}
              data-test-id={testId('dismissBtn')}>Dismiss</button>

            <button
              type="submit"
              className={css.loginBtn}
              onClick={this.onGoToLoginClick}
              data-test-id={testId('loginBtn')}>{dealsGroup === 2 ? 'View Deals' : 'Sign In'}</button>
          </form>
        </div>
      </aside>
    );
  }
}

function mapStateToProps(state) {
  const {
    cookies: {
      ['x-main']: isRecognizedCustomer,
      [CLOSED_LA_COOKIE]: hideLADueToCustomerClosedIt
    },
    routing: { locationBeforeTransitions }
  } = state;

  const dealsGroup = getAssignmentGroup(HYDRA_LASD, state);

  return {
    dealsGroup,
    isInDealsTest: dealsGroup !== 0,
    isRecognizedCustomer: !!isRecognizedCustomer,
    hideLADueToCustomerClosedIt: !!hideLADueToCustomerClosedIt,
    hydraPersonalizationMarker: getAssignmentGroup(HYDRA_PERSONALIZATION_MARKER, state),
    locationBeforeTransitions
  };
}

LoginAssistant.contextTypes = {
  marketplace: PropTypes.object,
  testId: PropTypes.func
};

export default connect(mapStateToProps, {
  onCloseLoginAssistantClick,
  onLoginFromLoginAssistantClick,
  onShowLoginAssistant,
  redirectToAuthenticationFor,
  triggerAssignment
})(LoginAssistant);
